import React, { useRef, useEffect, useCallback, useState} from 'react';
import {setSourceExploring} from 'actions/index.js';
import SamplesStreamTag from './SamplesStreamTag.js';
import {useTags} from "./useTags.js";
import SidebarSearch from "components/sidebar/SidebarSearch.js";
import {getBulkSampleInfo} from './getSamples.js';
import {useWindowClearer} from "components/sidebar/useWindowClearer.js"
import {
    setQuickAddSearchText,
    setSampleExplorerSelected} from 'actions/index.js';
import {useScroll} from "components/selector2/useScroll.js"
import '../../SamplesStream.scss';
import SampleStreamOption from './SampleStreamOption.js';
import {connect} from 'react-redux';

const TAGS = "TAGS";

let counter=0;

const SamplesStreamExplorer = ({
    isPianoRoll,
    track,
    stream,
    id,
    selectedSteps,
    setSampleExplorerSelected,
    sampleExplorerSelected,
    setSearchText,
    explorerMaximized,
    setSourceExploring
}) => { 
    let [filterFavorites, setFilterFavorites] = useState(false);

    const toggleFavorites = useCallback(() => {
        setFilterFavorites(!filterFavorites);
    }, [filterFavorites, setFilterFavorites]);

    let loadingSample = useRef(false);
    let ref = useRef(undefined);
    let [initialSize, setInitialSize] = useState(13);
    let {size} = useScroll(ref, initialSize, true, stream);
    let [samples, setSamples] = useState([]);

    let {tags, groupBy, setGroupBy} = useTags(samples, stream);

    useEffect(() => {
        return () => setSourceExploring(undefined);
    }, []);

    useEffect(() => {
        setSourceExploring(undefined);
    }, [stream]);

    useEffect(() => {
        setTimeout(() => {
            if (ref.current) {
                let newSize = ref.current.offsetHeight / 15;
                setInitialSize(newSize);
            }
        }, 100);
    }, [ref.current && ref.current.offsetHeight, setInitialSize, explorerMaximized]);

    useWindowClearer({
        clear: () => setSampleExplorerSelected(false),
        selected: sampleExplorerSelected
    });

    useEffect(() => {
        return () => setSampleExplorerSelected(false);
    }, []);

    const clickBack = useCallback(() => {
        track.backSamplesStream();
        if (track !== track.sequencerEngine.auditionTrack) {
            track.updateSteps();
            setSearchText('');
        }
    }, [track]);

    const clickForward= useCallback(() => {
        track.forwardSamplesStream();
        if (track !== track.sequencerEngine.auditionTrack) {
            track.updateSteps();
            setSearchText('');
        }
    }, [track]);

    useEffect(() => {
        if (stream && stream._sounds) {
            let _counter = ++counter;
            getBulkSampleInfo(stream._sounds, stream.id).then((s) => {
                if (_counter === counter) {
                    setSamples(s);
                } else {
                }
            });
        }
    }, [track, stream, setSamples, stream && stream._sounds]);

    const onClickTag = useCallback(async (tag, metaKey) => {
        loadingSample.current = true;
        setSearchText("");
        let tags=track.samplesStream.tags;
        let _tags = [tag];
        if (metaKey) {
            _tags = [...tags, ..._tags];
        }
        await track.sequencerEngine.searchForSounds(
            _tags, true, track, false);
        loadingSample.current = false;
    }, [track]);

    useEffect(() => {
        if (!track.samplesStream) {
            return;
        }
        let tags=track.samplesStream.tags;
        if (track.samplesStream.filterFavorites !== filterFavorites) {
            track.sequencerEngine.searchForSounds(
                tags, true, track, false, false, filterFavorites, false);
        }
    }, [filterFavorites]);

    if (!stream) {
        return [];
    }
    let soundIds = Array.from(new Set(stream.sounds || []));
    let explorerTags = Array.from(new Set(track.samplesStream.tags || []));
    let className = "samples-stream-explorer no-select";
    if (sampleExplorerSelected) {
        className += " selected";
    }
    let {backStreams, forwardStreams} = track;

    let inner = '';
    if (!groupBy) {
        inner  = samples.slice(0, size).map(
            (sample, i) => 
            <SampleStreamOption
              scrollRef={ref}
              onClickTag={onClickTag}
              loadingSample={loadingSample}
              tags={track.samplesStream.tags}
              track={track}
              selected={id === sample.getId()}
              key={sample.getId() + '-' + i}
              sample={sample}
              id={sample.getId()}/>);
    } else {
        let sortedTags = Object.keys(tags).sort(
            (a,b) => a.toLowerCase().localeCompare(b.toLowerCase()));
        
        inner = (sortedTags.map(
            (tag,i) => <SamplesStreamTag
                     scrollRef={ref}
                     onClickTag={onClickTag}
                     track={track}
                     stream={stream}
                     key={tag+',' + i}
                     loadingSample={loadingSample}
                     id={id}
                     tag={tag}
                     samples={tags[tag]}/>));
    }
    return (
        <div
          onMouseDown={(e) => {
              e.stopPropagation();
              setSampleExplorerSelected(true);
          }}
          className={className}>
          <div className="explorer-header">
             <div className="header-text">
               {backStreams.length + forwardStreams.length > 0 ?
              <div className="arrows">
                {backStreams.length > 0 ? <div onClick={clickBack} className="arrow-left"/> : ''}
                {forwardStreams.length > 0 ? <div onClick={clickForward} className={backStreams.length === 0 ? 'no-left arrow-right' : "arrow-right"}/> : ''}
              </div> : ''}
              {stream && stream.length} {explorerTags.map(
                  (tag, i) =>
                      <span
                        key={i}
                        onClick={() => onClickTag(tag)}
                            className={explorerTags.length === 1 ? "stream-type first last" :
                                       i===0 ? "stream-type first" :
                                       i===explorerTags.length - 1 ? "stream-type last" :
                                       "stream-type"}>
                        {tag} {i < explorerTags.length - 1 ? '+' : ''} </span>)} sounds
               <div onClick={toggleFavorites} className={filterFavorites ? "filter-by-favorites heart favorited" : "filter-by-favorites heart"}/>
               <img
                 onClick={() => setGroupBy(groupBy === TAGS ? undefined : TAGS)}
                 src="/tag.svg" className={groupBy === TAGS ? "tags-icon selected" : "tags-icon"}/>
            </div>
            {isPianoRoll ? <SidebarSearch sequencerEngine={track.sequencerEngine}/> : ''}
          </div>
          <div ref={ref} className="inner-explorer">
            {inner}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        selectedTrack: state.mix.selectedTrack,
        trackId: props.track.id,
      stream: props.track.samplesStream,
      ids: props.track.samplesStream &&
          props.track.samplesStream.sounds &&
          props.track.samplesStream.sounds.length,
      id: props.track.sample && props.track.sample.getId(),
      selectedSteps: state.keyboard.selectedPianoRollSteps,
        sampleExplorerSelected: state.selector.sampleExplorerSelected,
      explorerMaximized: state.selector.explorerMaximized
        
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSourceExploring: x => dispatch(setSourceExploring(x)),
      setSampleExplorerSelected: (x) => dispatch(setSampleExplorerSelected(x)),
      setSearchText: x => dispatch(setQuickAddSearchText(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SamplesStreamExplorer);
